module.exports = __webpack_public_path__ + "img/termometro-suelo.820af5b0.webp";